.initial-sync-ctas > * {
    margin-top: 16px;
    width: 350px;
}

.banner {
    margin-top: '32px';
}
